import { cleanObject } from 'tiny-clean-object';
import { isArray, isEqual, omitBy } from 'lodash-es';
const defaultCleanOptions = {
  /** @default true */
  deep: true,
  /** @default true */
  emptyArrays: true,
  /** @default true */
  emptyObjects: true,
  /** @default false */
  skipNulls: false,
  /** @default true */
  emptyInvalidNumbers: true,
  /** @default true */
  emptyStrings: true,
};
type CleanOptions = Partial<typeof defaultCleanOptions>;
export function isEqualClean<T extends {}>(a: T, b: T, opts: CleanOptions = defaultCleanOptions) {
  const options = { ...defaultCleanOptions, ...opts };
  const aClean = cleanObject(a, options);
  const bClean = cleanObject(b, options);
  return isEqual(aClean, bClean);
}

export function omitProps<T extends {}>(object: T, keysToRemove: (keyof T)[]) {
  return omitBy(object, (_value, key) => keysToRemove.includes(key as keyof T));
}

export function removeEmptyArrays<T extends {}>(value: T) {
  return omitBy(value, (v) => isArray(v) && v.length === 0);
}

export function deepFreeze(object: any) {
  // Retrieve the property names defined on object
  object = Object.isFrozen(object) ? Object.create(object) : object;
  const propNames = Object.getOwnPropertyNames(object);

  // Freeze properties before freezing self

  for (const name of propNames) {
    const value = object[name];

    object[name] = value != null && typeof value === 'object' ? deepFreeze(value) : value;
  }

  return Object.freeze(object);
}

export function removeUndefinedProps(obj: object) {
  if (typeof obj != 'object') {
    return obj;
  }
  const result = { ...obj } as any;
  Object.keys(result).forEach((key) => result[key] === undefined && delete result[key]);
  return result;
}
